import { receiveChatStream, type ChatStreamOptions } from "@/utils/chat_stream";
import type { DefaultApi, ResumeChatRequest } from "@/api";
import { ResumeChat } from "@/models/resume_chat";
import { ResumeChats } from "@/models/resume_chats";
import type { State as RootState } from "@/stores";
import type { Module } from "vuex";
export interface State {
  resumeChats?: ResumeChats;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    resumeChats: undefined,
  },
  actions: {
    async getResumeChat(
      { commit },
      {
        positionId,
        resumeId,
      }: {
        positionId: number;
        resumeId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getResumeChat(resumeId, positionId);
      const chats = new ResumeChats(
        response.data.map((chat: Partial<ResumeChat>) => new ResumeChat(chat)),
      );
      commit("setResumeChats", chats);
      return chats;
    },
    async postResumeChat(
      { commit },
      {
        positionId,
        resumeId,
        chatRequest,
        onText,
        onError,
        signal,
      }: {
        positionId: number;
        resumeId: number;
        chatRequest: ResumeChatRequest;
      } & ChatStreamOptions,
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const data = await receiveChatStream<ResumeChat[]>(
        (options) =>
          api.postResumeChat(positionId, resumeId, chatRequest, options),
        { onText, onError, signal },
      );
      const chats = new ResumeChats(
        data.map((chat: Partial<ResumeChat>) => new ResumeChat(chat)),
      );
      commit("appendResumeChats", chats);
      return chats;
    },
  },
  mutations: {
    setResumeChats(state, chats: ResumeChats) {
      state.resumeChats = chats;
    },
    appendResumeChats(state, chats: ResumeChats) {
      if (state.resumeChats === undefined) state.resumeChats = chats;
      else state.resumeChats = [...state.resumeChats, ...chats];
    },
  },
};
